import { errorHandler } from '@/app/shared/services/error-handler.js';

export default {

  //#region regions

  fetchRegionListItems({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$webApi.get("cashflow/region")
        .then((response) => {
          commit('SET_REGIONS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addRegion({ commit }, region) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/region/', region)
        .then((response) => {
          commit('ADD_REGION', Object.assign(region, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateRegion({ commit }, region) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/region/', region)
        .then((response) => {
          commit('UPDATE_REGION', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeRegion({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/region/' + id)
        .then((response) => {
          commit('REMOVE_REGION', id)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region projects

  fetchProjectListItems({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$webApi.get("cashflow/project")
        .then((response) => {
          commit('SET_PROJECTS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addProject({ commit }, project) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/project/', project)
        .then((response) => {
          commit('ADD_PROJECT', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateProject({ commit }, project) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/project/', project)
        .then((response) => {
          commit('UPDATE_PROJECT', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeProject({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/project/' + id)
        .then((response) => {
          commit('REMOVE_PROJECT', id)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  
  //#endregion

  //#region  hyperionLoms

  fetchHyperionLomListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("cashflow/hyperionLom")
        .then((response) => {
          commit('SET_HYPERION_LOMS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  //#endregion

  //#region projectLoms

  fetchProjectLomListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("cashflow/projectLom")
        .then((response) => {
          commit('SET_PROJECT_LOMS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addProjectLom({ commit }, projectLom) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/projectLom/', projectLom)
        .then((response) => {
          commit('ADD_PROJECT_LOM', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateProjectLom({ commit }, projectLom) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/projectLom/', projectLom)
        .then((response) => {
          commit('UPDATE_PROJECT_LOM', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeProjectLom({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/projectLom/' + id)
        .then((response) => {
          commit('REMOVE_PROJECT_LOM', id)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  
  //#endregion

  //#region corporateLoms

  fetchCorporateLomListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("cashflow/corporateLom")
        .then((response) => {
          commit('SET_CORPORATE_LOMS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addCorporateLom({ commit }, corporateLom) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/corporateLom/', corporateLom)
        .then((response) => {
          commit('ADD_CORPORATE_LOM', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateCorporateLom({ commit }, corporateLom) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/corporateLom/', corporateLom)
        .then((response) => {
          commit('UPDATE_CORPORATE_LOM', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeCorporateLom({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/corporateLom/' + id)
        .then((response) => {
          commit('REMOVE_CORPORATE_LOM', id)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  
  //#endregion

  //#region compilations

  fetchCompilationListItems({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$webApi.get("cashflow/compilation")
        .then((response) => {
          commit('SET_COMPILATIONS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addCompilation({ commit }, compilation) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/compilation/', compilation)
        .then((response) => {
          commit('ADD_COMPILATION', Object.assign(compilation, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateCompilation({ commit }, compilation) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/compilation/', compilation)
        .then((response) => {
          commit('UPDATE_COMPILATION', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeCompilation({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/compilation/' + id)
        .then((response) => {
          commit('REMOVE_COMPILATION', id)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  duplicateCompilation({commit }, id) {
    return new Promise((resolve, reject) => {
      // Somehow this._vm.$cqrsPost wasn't found
      this._vm.$webApi.post('cashflow/LOM/Compilations/Duplicate',  { id })
        .then((response) => {
          const data = response.data.model;
          commit('DUPLICATE_COMPILATION', data);
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error);
        });
    });
  },

  //#endregion

  //#region hyperion

  fetchHyperionEntityListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("cashflow/hyperionEntity")
        .then((response) => {
          commit('SET_HYPERION_ENTITIES', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  //#endregion

  //#region templates
  fetchYearlyFXRateTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("cashflow/lom/YearlyFxRateTemplates/findAll")
        .then((response) => {
          commit('SET_YEARLY_FX_RATE_TEMPLATES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchYearlyInflationRateTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("cashflow/lom/YearlyInflationRateTemplates/findAll")
        .then((response) => {
          commit('SET_YEARLY_INFLATION_RATE_TEMPLATES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchElementYearlyPriceTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("cashflow/lom/ElementYearlyPriceTemplates/findAll")
        .then((response) => {
          commit('SET_ELEMENT_YEARLY_PRICE_TEMPLATES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
